export const PAGINATION = {
  page: 1,
  size: 25,
}
export const STATUS = [
  { value: 1, label: '待划转' },
  { value: 2, label: '划转中' },
  { value: 3, label: '划转完成' },
  { value: 4, label: '划转失败' },
]

export const FROM = [
  { value: 'OTC', label: '资金账户' },
  { value: 'CONTRACT', label: '合约账户' },
  { value: 'SPOT', label: '现货账户' },
]

export const TO = [
  { value: 'OTC', label: '资金账户' },
  { value: 'CONTRACT', label: '合约账户' },
  { value: 'SPOT', label: '现货账户' },
]
export const STATUSTEXT = {
  1: '待划转',
  2: '划转中',
  3: '划转完成',
  4: '划转失败',
}
export const TYPES = {
  OTC: '资金账户',
  CONTRACT: '合约账户',
  SUPER: '超级合约钱包',
  SPOT: '现货账户'
}
